var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3333 16.2719V18.3001C29.3333 23.5011 29.3333 26.1018 27.7712 27.7175C26.2092 29.3334 23.6949 29.3334 18.6667 29.3334H13.3334C8.30503 29.3334 5.79089 29.3334 4.22878 27.7175C2.66669 26.1018 2.66669 23.5011 2.66669 18.3001V16.2719C2.66669 13.2207 2.66669 11.6951 3.35895 10.4304C4.05122 9.16569 5.31595 8.38076 7.84539 6.81092L10.5121 5.15591C13.1859 3.49647 14.5228 2.66675 16 2.66675C17.4772 2.66675 18.8141 3.49647 21.488 5.15591L24.1547 6.81091C26.6841 8.38076 27.9488 9.16569 28.6411 10.4304",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 24H12",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/houseIcon.b48957bbd20de5c244764b37db996b55.svg";
export { ForwardRef as ReactComponent };